import { useState } from 'react';

import { Modal, Spin } from 'antd';

import { ReactComponent as Add } from '../../../assets/add.svg';
import { Button } from '../../../custom';
import { useGetRequiredDocumentsQuery } from '../../../hooks/api/useGetRequiredDocumentsQuery';
import styles from '../styles.module.scss';

import RequiredDocumentForm from './requiredDocumentForm';
import RequiredDocumentTable from './requiredDocumentTable';

const RequiredDocumentSetup = () => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<RequiredDocument | null>(null);

  const {
    requiredDocumentsData,
    isRequiredDocumentsLoading,
    isRequiredDocumentsError,
    requiredDocumentsErrorMessage,
  } = useGetRequiredDocumentsQuery();

  const handleClose = () => {
    setOpenModal(false);
    setSelectedRecord(null);
  };

  const handleEdit = (record: RequiredDocument) => {
    setSelectedRecord(record);
    setOpenModal(true);
  };

  if (isRequiredDocumentsLoading) {
    return <Spin size="large" />;
  }

  if (isRequiredDocumentsError) {
    return <div>Error: {requiredDocumentsErrorMessage}</div>;
  }

  return (
    <main>
      <section className="space-between">
        <h3>Required Document Setup</h3>
        <Button
          onClick={() => {
            setSelectedRecord(null);
            setOpenModal(true);
          }}
          iconBefore={<Add />}
          text="Setup"
        />
      </section>

      <section className={styles.card}>
        <RequiredDocumentTable data={requiredDocumentsData} onEdit={handleEdit} />
      </section>

      <Modal
        open={openModal}
        onCancel={handleClose}
        centered
        title={selectedRecord?.id ? 'Edit Required Document' : 'Required Document Setup'}
        footer={null}
      >
        <RequiredDocumentForm handleClose={handleClose} record={selectedRecord} />
      </Modal>
    </main>
  );
};

export default RequiredDocumentSetup;
